import { create } from 'zustand';
import { ApiUtils, CardApi, CardEntity, RequestStrategyEnum } from '@shared/api';

interface IReprintCardStore {
  loading: boolean;
  error: string | null;
  card: CardEntity[];
  reprintPin: (accountId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useReprintCardStore = create<IReprintCardStore>((set) => ({
  loading: false,
  error: null,
  card: [],

  reprintPin: ApiUtils.wrapperApi(async (accountId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardApi.reprintPin(accountId, signal);
      set({ card: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ card: [], loading: false, error: null }),
}));
